import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

/** Indeterminate loading indicator. */
export function Spinner({ className, label = 'Loading' }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-label={label} className="inline-flex">
      <Loader2 className={cn('size-4 animate-spin text-ink-faint', className)} strokeWidth={2} />
    </span>
  );
}
